import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Login } from "./login";
import 'rxjs/add/operator/debounceTime';
import { AuthService } from "../../auth.service";
import { AppCommonService } from "../../appcommon.service";
import { GlobalService } from "../../global.service";
import { LoaderService } from "../../LoaderService";
import { Subscription } from "rxjs";
import { IdentityUser } from "../../users/user";
import { HeaderAndNavigationService } from "../headerandnavigation.service";

declare var $: any;

@Component({
  selector: '[mft-identitylogin]',
  templateUrl: './identitylogin.component.html'
})
export class IdentityLoginComponent implements OnInit {  

  constructor(    
    private authService: AuthService,
    private appCommonService: AppCommonService,
    private router: Router,
    public globalService: GlobalService,
    public loaderService: LoaderService,
    public headerAndNavigationService: HeaderAndNavigationService
  ) {        
  }

  ngOnInit(): void {
    
  }  
  
  ngAfterViewInit() {
    
  }

  public login() {
    //debugger;
    this.authService.login();
  }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/login/identitylogin.component.ts